module.exports = __webpack_public_path__ + "img/content-04@2x.d1e60afe.png";